import { Component } from '@angular/core';

@Component({
    selector: 'app-kiosk-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    standalone: false
})
export class MainComponent  {}
